<section class="dynamic-form-item-element item-named-{{item.name}}"
         [ngClass]="{
           'required': item.required && !item?.hideAsterisks,
           'dynamic-form-invalid':(!item.isRootProperty && formInstance.controls[item.name]?.invalid && (submitted || formInstance.controls[item.name]?.dirty || editMode) && (item.type?.toUpperCase() !== 'WIDGET')),
           'form-item-column': isClickable && item.type !== 'select',
           'independent-form-item': isIndependent,
           'wrapped-fields': item.attributes && item.attributes.wrapLabelVue
         }"
         [formGroup]="formInstance">
  <div class="Flexbox dynamic-form-item-label-wrapper" *ngIf="item.type !== 'upload' && isNotEmptyLabel()"
       [ngClass]="item.attributes && item.attributes.labelWrapperCss || ''"
  >
    <label *ngIf="((item.tooltip != 'null') && !item.labelExt)" class="dynamic-form-item-label form-label-12-rem"
           genTooltip
           [tooltipText]="labelTooltipText$ | async | stringTranslate"
           [tooltipPosition]= "tooltipPosition"
           [tooltipShow]="tooltipShow"
           genEllipsis
           [ngClass]="item.attributes && item.attributes.labelCss || ''"
           (tooltipStateEmit)="truncate($event)"
       >
      {{item.label | stringTranslate}}
    </label>
    <label *ngIf="((item.tooltip == 'null') && !item.labelExt)" class="dynamic-form-item-label form-label-12-rem"
           [ngClass]="item.attributes && item.attributes.labelCss || ''">
      {{item.label | stringTranslate}}
    </label>
    <label class="prompt" *ngIf="item.prompt">{{getPrompt(item.prompt)}}</label>
    <gen-form-item-label *ngIf="item.labelExt"
                         [formData]="formInstance.value"
                         [labelConfig]="item.labelExt"
                         [prefix]="item.labelExt.prefix"
                         [templateType]="item.labelExt.templateType"
                         [payload]="item.labelExt.payload"
                         (linkClick)="linkClicked($event)"
    ></gen-form-item-label>

    <ng-container *ngIf="item.labelInfo">
      <!--TODO change iconCss to icon Class-->
      <gen-info-box class="label-info-icon"
                    [iconType]="'info'"
                    [iconCss]="item.labelInfo?.iconCss"
                    [tooltipShow]="getToolTopVisibility(item.labelInfo)"
                    [tooltipText]="getTooltipText(item.labelInfo)"
                    [tooltipPosition]="getTooltipPosition(item.labelInfo)"


      ></gen-info-box>
    </ng-container>
  </div>
  <div class="dynamic-form-input-section-wrapper" [attr.triggerBlurItem]="isTriggerBlurItem" [ngClass]="formId + '-' + item.name">
    <gen-editable-parameter
      [required]="item.required"
      [value]="item.type != 'password' ? getValue(item.name) : '************'"
      [requiredMessage]="requiredMessage"
      [isEditableField]="isFieldEditable && !disabled"
      [formMode]="formMode"
      [editableInitMode]="formMode || editableInitMode"
      [disabled]="editMode && disabled"
      [title]="null"
      [displayTooltip]="false"
      [tooltipWrapperClass]="item['toolTipWrapperClass']"
      (click)="(updateOn === 'click')?updateTouched($event,false):''"
      (mousedown)="(updateOn === 'mousedown')?updateTouched($event,false):''"
      (update)="updateEditForm(item.name)"
      [tooltipText]="tooltipText$ | async"
      [tooltipConfiguration]="item.tooltipConfiguration"
      [tooltipPosition]="item.tooltipConfiguration?.tooltipPosition"
      [tooltipData]="item?.tooltipConfiguration?.pathToData ? (fullFormData$ | async) : null"
      [formId]="formId"
      [checkClicksOn]="item.options?.checkClicksOn"
      [excludeClicksOn]="item.options?.excludeClicksOn"
      [showAsLink]="item.showAsLink"
      [showAsTextWithLink]="item.showAsTextWithLink"
      [linkPrefix]="item.linkPrefix"
      [parentHandleLink]="item.parentHandleLink"
      [showLinkSuffix]="item.showLinkSuffix"
      [hideEditIcon]="isIndependent"
      [interpolateObject]="item.patternValuesPath !== '' ? getValue(item.patternValuesPath || item.name) : formInstance.getRawValue()"
      [key]="getKey(transformToTemplate?.display)"
      [ngClass]="itemValueClass"
      [classes]="'dynamic-form-item-input-wrapper'"
      [stayEditable]="(isIndependent || forceItemFormMode) && !forceDeepBlur"
      [stayEditableOn]="'main_value'"
      [isParamValid]="isFieldValid().bind(this)"
      [displayPattern]="item.displayPattern | stringTranslate"
      [separator]="item.displaySeparator"
      [ignoreMarginRight]="ignoreMargin"
      [editableItemEmptyValueText]="editableItemEmptyValueText"
      (linkClick)="linkClicked($event)"
      [interpolationOptions]="item.interpolationOptions"
      [icon]="item.icon"
      [hyphenate]="item.hyphenate"
      [fieldType]="item.type"
      [fieldAttributes]="item.attributes"
      [defaultList]="_defaultList"
      [additionalSearchValues]="additionalSearchValues"
      [isItDefault]= "item.isItDefault"
      [label]="item.label"
      [promptSeparator]="!!item.prompt"
    >
      <div class="dynamic-form-item-input" [style.cursor]="disableTillFetched ? 'no-drop' : 'default'" [ngSwitch]="getItemEnum(item.type)">

        <span  *ngSwitchCase="getItemEnum('placeholder')">

        </span>

        <!--number input start-->
        <input class="dynamic-form-item-input form-control {{automationClass}} dynamic_form_item_selector"
               *ngSwitchCase="getItemEnum('number')"
               (contextmanu)="toggleMenu($event)"
               [placeholder]="item.placeholder | stringTranslate"
               (focus)="updateTouched($event,false)"
               (blur)="updateTouched($event,true); onBlur($event)"
               deep-blur
               placeholder="{{item.placeholder | stringTranslate}}"
               type="number"
               [min]="item.min || item.attributes.min"
               [max]="item.max || item.attributes.max"
               [step]="item.step"
               formControlName="{{item.name}}"
               restrict-input-length
               [form]="formInstance"
               [formItem]="item"
        />
        <!--number input end-->

        <!--text input start-->
        <input class="dynamic-form-item-input form-control {{automationClass}} dynamic_form_item_selector" type="text"
               *ngSwitchCase="getItemEnum('text')"
               (contextmanu)="toggleMenu($event)"
               deep-blur
               (focus)="updateTouched($event,false)"
               (blur)="updateTouched($event,true);onBlur($event)"
               placeholder="{{item.placeholder | stringTranslate}}"
               formControlName="{{item.name}}"
               [attr.disabled]="formInstance.controls[item.name]?.disabled || null"
        />
        <!--text input end-->

        <!--password input start-->
        <input class="dynamic-form-item-input form-control {{automationClass}} dynamic_form_item_selector" type="password"
               *ngSwitchCase="getItemEnum('password')"
               (contextmanu)="toggleMenu($event)"
               deep-blur
               autocomplete="off"
               (focus)="updateTouched($event,false)"
               (blur)="onBlur($event)"
               placeholder="{{item.placeholder | stringTranslate}}"
               formControlName="{{item.name}}"/>
        <!--password input end-->

        <!--textarea start-->
        <textarea *ngSwitchCase="getItemEnum('textarea')"
                  class="dynamic-form-item-input form-control {{automationClass}} dynamic_form_item_selector dynamic-form-item-text-area-wrapper"
                  deep-blur
                  placeholder="{{item.placeholder | stringTranslate}}"
                  formControlName="{{item.name}}"
                  [style.height]="textMinHeight"
                  [style.maxHeight]="textMaxHeight"
                  (contextmenu)="toggleMenu($event)"
                  (focus)="updateTouched($event,false)"
                  (blur)="updateTouched($event,true);onBlur($event)"
                  (keyup)="onTextArea($event)"
        ></textarea>
        <!--textarea end-->

        <!--radio start-->
        <section class="dynamic-form-item-input {{automationClass}} dynamic_form_item_selector"
                 *ngSwitchCase="getItemEnum('radio')">
            <dls-radio-button *ngFor="let option of options$|async"
                              [ngClass]="option[transformToTemplate?.code] | automationLocator:'VALUE'"
                              (blur)="onBlur($event)"
                              (focus)="updateTouched($event,false)"
                              (click)="radioClick(option.code)"
                              name="{{formId+item.name}}"
                              [formControl]="getControl()"
                              [value]="option[transformToTemplate?.code]"
                              [attr.disabled]="isOptionDisabled(option)">{{option[transformToTemplate?.display] | stringTranslate}}</dls-radio-button>
        </section>
        <!--radio end-->

        <!--normal checkbox start-->
        <section class="dynamic-form-item-input {{automationClass}} dynamic_form_item_selector"
                 *ngSwitchCase="getItemEnum('checkbox')" >
          <ng-container *ngIf ="!_defaultList">
            <p-checkbox *ngFor="let option of options$|async"
                        [ngClass]="option[transformToTemplate?.code] | automationLocator:'VALUE'"
                        checkboxIcon="icon__Checkmark1"
                        name="{{formId+item.name}}"
                        [formControl]="getControl()"
                        (contextmanu)="toggleMenu($event)"
                        (blur)="onBlur($event)"
                        (focus)="updateTouched($event,false)"
                        binary="{{item?.attributes && item?.attributes['[binary]']}}"
                        label="{{option[transformToTemplate?.display] | stringTranslate}}"
                        value="{{option[transformToTemplate?.code]}}"
                        class="p-checkbox"
                        [dlsTooltip]="valueTooltipText$ | async | stringTranslate"
                        [tooltipPosition]="'Bottom'"
                        [tooltipShowDelay]="10"
                        [tooltipHideDelay]="1"
            ></p-checkbox>
          </ng-container>
          <ng-container *ngIf ="_defaultList || item.defaultList">
            <p-checkbox *ngFor="let option of options$|async | excludeInclude:_defaultList:'INCLUDE'"
                        [ngClass]="option[transformToTemplate?.code] | automationLocator:'VALUE'"
                        checkboxIcon="icon__Checkmark1"
                        name="{{formId+item.name}}"
                        [formControl]="getControl()"
                        (contextmanu)="toggleMenu($event)"
                        (blur)="onBlur($event)"
                        (focus)="updateTouched($event,false)"
                        binary="{{item?.attributes && item?.attributes['[binary]']}}"
                        label="{{option[transformToTemplate?.display] | stringTranslate}}"
                        value="{{option[transformToTemplate?.code]}}"
                        class="p-checkbox"
            ></p-checkbox>
          </ng-container>
        </section>
        <!--normal checkbox end-->

        <!--autocomplete start-->
        <ng-container *ngSwitchCase="getItemEnum('autocomplete')">
          <i *ngIf="item?.attributes && item?.attributes['[includeMagnifier]'] === true" class="magnifier icon__search"></i>
          <p-autoComplete deep-blur
                          class="dynamic-form-item-input dynamic_form_item_selector"
                          [showEmptyMessage]="true"
                          emptyMessage="Not Found"
                          field="{{transformToTemplate?.display||null}}"
                          formControlName="{{item.name}}"
                          immutable="true"
                          inputId="{{'autocomplete-input_' + item.name + '_' + itemIndex + '_' + randomId}}"
                          inputStyleClass="form-control text-override {{item.name}} Auto_Input"
                          placeholder="{{item.placeholder | stringTranslate}}"
                          [appendTo]="item?.attributes && item?.attributes['[appendTo]'] !== undefined ? item?.attributes['[appendTo]'] : popupMode"
                          [dataKey]="transformToTemplate?.code"
                          [emptyMessage]="'Not found'"
                          [forceSelection]="forceSelection"
                          [minLength]="item?.attributes && item?.attributes['[minLength]'] !== undefined ? item?.attributes['[minLength]'] : 1"
                          [required]="item.required"
                          [suggestions]="options$|async"
                          [virtualScroll]="false"
                          [itemSize]="item?.attributes && item?.attributes['[itemSize]'] !== undefined ? item?.attributes['[itemSize]'] : 34"
                          (completeMethod)="search($event)"
                          (onBlur)="updateTouched($event,true);onBlur($event)"
                          (onFocus)="onFocus($event)"
          >
            <ng-template let-value pTemplate="item">
              <gen-suggestions-template [object]="value"
                                        [translate]="item?.attributes['translate']"
                                        [fieldTemplate]="item.fieldTemplate||''"
                                        [fieldsToDisplay]="fieldsToDisplay"
                                        [mainValue]="getSuggestionValue(value)"
              >
              </gen-suggestions-template>
            </ng-template>
          </p-autoComplete>
        </ng-container>
        <!--autocomplete end-->

<!--        <section style="position: relative">-->
        <!--dropdown start-->
        <p-autoComplete *ngSwitchCase="getItemEnum('dropdown')"
                        [dropdown]="item?.attributes && item?.attributes['[dropdown]'] !== undefined ? item?.attributes['[dropdown]'] : true"
                        class="dynamic-form-item-input dynamic_form_item_selector"
                        [showEmptyMessage]="true"
                        emptyMessage="Not Found"
                        field="{{transformToTemplate?.display||null}}"
                        formControlName="{{item.name}}"
                        immutable="true"
                        inputId="{{'autocomplete-input_'+ itemIndex + '_' + item.name + '_' + randomId }}"
                        inputStyleClass="form-control text-override {{item.name}} Auto_Input"
                        placeholder="{{item.placeholder | stringTranslate}}"
                        (completeMethod)="search($event)"
                        [appendTo]="item?.attributes && item?.attributes['[appendTo]'] !== undefined ? item?.attributes['[appendTo]'] : popupMode"
                        [dataKey]="transformToTemplate?.code"
                        [forceSelection]="forceSelection"
                        [minLength]="item?.attributes && item?.attributes['[minLength]'] !== undefined ? item?.attributes['[minLength]'] : 1"
                        [required]="item.required"
                        [suggestions]="options$| async"
                        [virtualScroll]="false"
                        [itemSize]="item?.attributes && item?.attributes['[itemSize]'] !== undefined ? item?.attributes['[itemSize]'] : 34"
                        [type]="item?.attributes && item?.attributes['[showClearInputButton]'] === true ? 'search' : 'text'"
                        (contextmenu)="toggleMenu($event)"
                        (onBlur)="updateTouched($event,true);onBlur($event, false)"
                        (onClear)="onClear($event)"
                        (onFocus)="onFocus($event)">
          <ng-template let-value pTemplate="item">
            <gen-suggestions-template [object] = "value"
                                      [translate]="item?.attributes['translate']"
                                      [fieldTemplate]="item.fieldTemplate || ''"
                                      [fieldsToDisplay]="fieldsToDisplay"
                                      [mainValue]="transformToTemplate?.display ? value[transformToTemplate?.display]:value"
            ></gen-suggestions-template>
          </ng-template>
        </p-autoComplete>
        <!--dropdown end-->

        <!--upload component start-->
        <gen-file-upload *ngSwitchCase="getItemEnum('upload')"
                         [formControlName]="item.name"
                         [data]="getValue(item.name)"
                         [displayType]="item?.attributes.displayType"
                         [storageName]="item.storageName"
                         [fileExtension]="item.fileExtension"
                         [fileButtonText]="item.fileButtonText"
                         [useFriendlyName]="item.useFriendlyName"
                         [checksumAlgorithm]="item.checksumAlgorithm"
                         [fileFields]="item.fieldsToDisplay"
                         [maxFileSize]="item.maxFileSize"
                         [processorType]="item.processorType"
                         [label]="item.label"
                         [preUploadWarning]="item.preUploadWarning"
                         [fileProcessorOptions]="item.fileProcessorOptions"
                         [disabled]="disabled"
                         [skipFileExtValidation]="item.skipFileExtValidation"
                         (onFocus)="onFocus(($event))"
                         [item]="item"
        >
          <ng-template let-item>
            <gen-uploaded-file-details
                    (click)="onFocus($event)"
                    [fileFields]="item.data"
                    [deleteFileCallback]="item.deleteFileCallback"
                    [warningImageUrl]="item.warningImageUrl"
                    [disabled]="disabled"></gen-uploaded-file-details>
          </ng-template>
        </gen-file-upload>
        <!--upload component end-->

        <!--multiselect start-->
        <p-autoComplete *ngSwitchCase="getItemEnum('multiselect')" #multiselect
                        class="dynamic-form-item-input dynamic_form_item_selector multiselect"
                        deep-blur
                        [showEmptyMessage]="true"
                        emptyMessage="Not Found"
                        field="{{transformToTemplate?.display||null}}"
                        formControlName="{{item.name}}"
                        immutable="true"
                        inputId="{{'autocomplete-input_' + item.name + '_' + itemIndex + '_' + randomId}}"
                        inputStyleClass="text-override {{item.name}} Auto_Input"
                        placeholder="{{item.placeholder | stringTranslate}}"
                        [appendTo]="item?.attributes && item?.attributes['[appendTo]'] !== undefined ? item?.attributes['[appendTo]'] : popupMode"
                        [dataKey]="transformToTemplate?.code"
                        [dropdown]="item?.attributes && item?.attributes['[dropdown]'] !== undefined ? item?.attributes['[dropdown]'] : true"
                        [emptyMessage]="'Not found'"
                        [forceSelection]="forceSelection"
                        [minLength]="item?.attributes && item?.attributes['[minLength]'] !== undefined ? item?.attributes['[minLength]'] : 1"
                        [multiple]="multiple"
                        [required]="item.required"
                        [suggestions]="options$|async"
                        [virtualScroll]="false"
                        [itemSize]="item?.attributes && item?.attributes['[itemSize]'] !== undefined ? item?.attributes['[itemSize]'] : 34"
                        (completeMethod)="search($event)"
                        (contextmenu)="toggleMenu($event)"
                        (onBlur)="updateTouched($event,true); sanitizeMultiselectFormInput()"
                        (onKeyUp)="updateTouched($event,true);"
                        (onUnselect)="updateTouched($event, true);onBlur($event,!(multiple != null ? multiple : true))"
                        (onFocus)="onFocus($event)"
        >
          <ng-template let-value pTemplate="item">
            <gen-suggestions-template [object]="value"
                                      [translate]="item?.attributes['translate']"
                                      [fieldTemplate]="item.fieldTemplate||''"
                                      [fieldsToDisplay]="fieldsToDisplay"
                                      [mainValue]="transformToTemplate?.display ? value[transformToTemplate?.display]:value">
            </gen-suggestions-template>
          </ng-template>
        </p-autoComplete>
        <!--multiselect end-->

        <!--multiselect With Manual start-->
        <s-autoComplete *ngSwitchCase="getItemEnum('MULTISELECT_WITH_MANUAL')"
                        class="dynamic-form-item-input dynamic_form_item_selector"
                        deep-blur
                        emptyMessage="Not Found"
                        field="{{transformToTemplate?.display||null}}"
                        formControlName="{{item.name}}"
                        immutable="true"
                        inputId="{{'autocomplete-input_' + item.name + '_' + itemIndex + '_' + randomId}}"
                        inputStyleClass="text-override {{item.name}} Auto_Input"
                        placeholder="{{item.placeholder | stringTranslate}}"
                        [appendTo]="item?.attributes && item?.attributes['[appendTo]'] !== undefined ? item?.attributes['[appendTo]'] : popupMode"
                        [dropdown]="item?.attributes && item?.attributes['[dropdown]'] !== undefined ? item?.attributes['[dropdown]'] : false"
                        [ignoreCSSClass] = "!!(item?.ignoreCSSClass)"
                        [considerCSSClass] = "!!(item?.considerCSSClass)"
                        [minLength]="item?.attributes && item?.attributes['[minLength]'] !== undefined ? item?.attributes['[minLength]'] : 1"
                        [multiple]="multiple"
                        [removable]="item?.additional?.removable"
                        [suggestions]="options$|async"
                        [disableToggleMenuByField] = "item?.disableToggleMenuByField"
                        [skipSpecialCharValidation] = "item?.attributes && item?.attributes['[skipSpecialCharValidation]']  !== undefined ? item?.attributes['[skipSpecialCharValidation]'] : false"
                        (completeMethod)="search($event)"
                        (contextMenuEmitter)="toggleMenu($event)"
                        (onBlurEmit)="updateTouched($event,true);"
                        (onExitEditMode)="onBlur($event, false)"
                        (onFocus)="onFocus($event)"
                        (onUnselect)="updateTouched($event,true)"
        >
          <ng-template let-value pTemplate="item">
            <gen-suggestions-template [object]="value"
                                      [translate]="item?.attributes['translate']"
                                      [fieldTemplate]="item.fieldTemplate || ''"
                                      [fieldsToDisplay]="fieldsToDisplay"
                                      [multiple]="multiple"
                                      [mainValue]="transformToTemplate?.display ? value[transformToTemplate?.display]:value">
            </gen-suggestions-template>
          </ng-template>
        </s-autoComplete>
        <!--multiselect With Manual end-->

        <!--chips start-->
        <p-chips *ngSwitchCase="getItemEnum('chips')"
                 deep-blur
                 (onFocus)="onFocus($event)"
                 (onBlur)="onBlur($event)"
                 (contextmanu)="toggleMenu($event)"
                 inputStyleClass="{{item.name}} Auto_Input"
                 placeholder="{{item.placeholder | stringTranslate}}"
                 formControlName="{{item.name}}"></p-chips>
        <!--chips end-->

        <!--toggle start-->
        <p-selectButton *ngSwitchCase="getItemEnum('toggle')"
                        deep-blur
                        class="dynamic_form_item_selector"
                        styleClass="{{item.name}} Auto_Input"
                        [options]="(options$|async|transformObject:primeNgTransformTemplate)"
                        (onChange)="updateTouched($event,false)"
                        (contextmanu)="toggleMenu($event)"
                        formControlName="{{item.name}}"></p-selectButton>
        <!--toggle end-->

		  <!--toggle_button start -->
        <dls-toggle-group [class.pt-quiet]="item.cssClass == 'pt-quiet' && disabled" *ngSwitchCase="getItemEnum('toggle_button')" mode="radio" disabled="{{disabled}}">
          <button *ngFor="let option of options$|async"
                  dlsToggleButton
                  [(ngModel)]="alignment"
                  name="{{option[transformToTemplate?.dispaly]}}"
                  formControlName="{{item.name}}"
                  value="{{option[transformToTemplate?.code]}}"
           >{{option[transformToTemplate?.display] | stringTranslate}}</button>
        </dls-toggle-group>
        <!--toggle_button end -->

        <!--toggle_switch start-->
        <gen-toggle-switch
                *ngSwitchCase="getItemEnum('toggle_switch')"
                [disabled]="disabled"
                [active]="getValue()"
                (statusUpdate)="updateForm($event)"
        ></gen-toggle-switch>
        <!--toggle_switch end-->

        <!--select start-->
        <ng-container *ngSwitchCase="getItemEnum('select')">
          <select [ngClass]="{invisible: disableTillFetched}"
                  deep-blur
                  class="form-control {{automationClass}} dynamic_form_item_selector"
                  [compareWith]="compareBy()"
                  (contextmanu)="toggleMenu($event)"
                  (focus)="updateTouched($event,false)"
                  formControlName="{{item.name}}">
            <option *ngIf="addNotSelectedOption()"
                    [ngValue]="null">- Not Selected -</option>

            <option *ngFor="let option of options$|async;let i = index ; trackBy: (option ? option[transformToTemplate?.code] : i)"
                    [ngValue]="option">
                  <ng-container *ngIf="item.attributes['translate']">{{getOptionByProperty(option,transformToTemplate?.display)|translate}}</ng-container>
                  <ng-container *ngIf="!item.attributes['translate']">{{getOptionByProperty(option,transformToTemplate?.display)}}</ng-container>
            </option>
          </select>
          <div class="form-control" [ngClass]="{fetching: disableTillFetched, invisible: !disableTillFetched}">
            <div class="item-spinner"></div>
          </div>
        </ng-container>
<!--        select end-->

        <!--calendar start-->
        <gen-calendar-wrapper *ngSwitchCase="getItemEnum('datepicker')"
                              deep-blur
                              [inputClass]="'form-control input-with-button-override text-override '+automationClass +'dynamic_form_item_selector'"
                              [formControlName]="item.name"
                              [placeholder]="item?.placeholder | stringTranslate"
                              [appendTo]="item?.attributes && item?.attributes['[appendTo]'] !== undefined ? item?.attributes['[appendTo]'] : popupMode"
                              [showIcon]="item?.attributes && item?.attributes['[showIcon]'] !== undefined ? item?.attributes['[showIcon]'] : true"
                              [yearNavigator]="item?.attributes && item?.attributes['[yearNavigator]'] !== undefined ? item?.attributes['[yearNavigator]'] : true"
                              [showTime]="item?.attributes && item?.attributes['[showTime]'] !== undefined ? item?.attributes['[showTime]'] : false"
                              [dataType]="item?.attributes && item?.attributes['[showTime]'] !== undefined ? 'date' : 'string'"
                              [maxDate]="item?.attributes && item?.attributes['[maxDate]']"
                              [minDate]="item?.attributes && item?.attributes['[minDate]']"
                              [monthNavigator]="item?.attributes && item?.attributes['[monthNavigator]'] !== undefined ? item?.attributes['[monthNavigator]'] : true"
                              [selectionMode]="item?.selectionMode"
                              [inline]="item?.attributes && item?.attributes['[inline]']"
                              [showButtonBar]="item?.attributes && item?.attributes['[showButtonBar]']"
                              [confirmEditing] = "item.confirmEditing"
                              (onFocus)="onFocus($event)"
                              (blured)="updateTouched($event,true)"
                              (contextmenu)="toggleMenu($event)"
                              (dateSelected)="calendarDateSelectedEvent($event)"
                              [usePlatformFormatForDate] = "item?.attributes && item?.attributes['usePlatformFormatForDate'] !== undefined ? item?.attributes['usePlatformFormatForDate']: true"

        >
        </gen-calendar-wrapper>
        <!--calendar end-->

        <!-- derived-field-->
        <gen-derived-field
                class="dynamic-form-item-input {{automationClass}} dynamic_form_item_selector"
                *ngSwitchCase="getItemEnum('derived')"
                (change)="updateTouched($event, true) || updateForm($event)"
                [value]="getValue()"
                [widgetPayload]="item.widgetPayload"
                [displayPattern]="item.displayPattern"
                [formInstance]="formInstance"
        >
        </gen-derived-field>
        <!-- derived-field end-->

        <!--container start-->
        <!-- DEPRECATED feature  - currently ONLY ONE container per dynamic form is supported -->
        <section class="dynamic-form-item-input {{automationClass}} dynamic_form_item_selector dynamic_form_container"
                 *ngSwitchCase="getItemEnum('container')">
          <ng-container *ngTemplateOutlet="containerContent;context:{item:item,payload:item?.attributes?.payload,value:getControl().value}"></ng-container>
        </section>
        <!--container end-->

        <!-- widget start -->
        <section class="dynamic-form-item-input {{automationClass}} dynamic_form_item_selector"
                 *ngSwitchCase="getItemEnum('widget')">
          <!-- //TODO
              Binding of onfocus onBlur may not required to all the widgets will be performance hit
              already force emitter is default which will set the last touched item -->
          <gen-widget-item
            (onAddControl)="addControl($event)"
            (onFocus)="onFocus($event)"
            (onBlur)="updateTouched($event,true)"
            (forceUpdateEmitter)="setForceChange($event)"
            (submitUpdateEmitter)="updateSubmitStatus($event)"
            [value]="value$ | async"
            [disabled]="disabled"
            [pathToField]="item?.pathToField"
            [submitted]="submitted"
            [options]="(options$|async|transformObject:primeNgTransformTemplate)"
            [item]="item"
            [formId]="formId"
            [formBaseWidgetPayload]="formBaseWidgetPayload"
            [formInstance]="formInstance"
          ></gen-widget-item>
        </section>
        <!-- widget end -->
      </div>
      <gen-invalid-tooltip class="invalid-tooltip-wrapper"
                           *ngIf="!hideInvalidTooltip"
                           [ngClass]="item['toolTipWrapperClass']"
                           [tooltipPlacement]="'top'"
                           [tooltipRequired]="shouldShowTooltip()"
                           [tooltipText]="getInvalidTooltipText(item, (item.label ? (item.label | stringTranslate) : ''))"
                           [invalidTooltipText]="item?.attributes && item?.attributes['[invalidTooltipText]'] !== undefined ? (item?.attributes['[invalidTooltipText]'] | stringTranslate) : ''"
      ></gen-invalid-tooltip>
    </gen-editable-parameter>
    <ng-container *ngIf="item.valueInfo">
      <gen-info-box
        [ngClass]="'info-box-component'"
        [iconType]="'info'"
        [iconCss]="item.valueInfo.iconCss"
        [message]="item.valueInfo.text"
        [textCss]="item.valueInfo.textCss"
      ></gen-info-box>
    </ng-container>
  </div>
  <section class="context-section" (clickOutside)="showMenu = null" *ngIf="!!showMenu">
    <ng-container *ngTemplateOutlet="contextTemplate;context:contextMenuPayload"></ng-container>
  </section>
</section>

<ng-content></ng-content>

<ng-content select="[container-content]"></ng-content>
